module.exports = __webpack_public_path__ + "static/icon_milano_sudovest_nero-8dd783269ba1b0b2073b1f9f894b7d19.svg";